import { render, staticRenderFns } from "./InputMultiSelect.vue?vue&type=template&id=4c319fca&"
import script from "./InputMultiSelect.vue?vue&type=script&lang=js&"
export * from "./InputMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VCombobox,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c319fca')) {
      api.createRecord('4c319fca', component.options)
    } else {
      api.reload('4c319fca', component.options)
    }
    module.hot.accept("./InputMultiSelect.vue?vue&type=template&id=4c319fca&", function () {
      api.rerender('4c319fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputMultiSelect.vue"
export default component.exports